import { resetButtonStylingCSS } from '@tmh-website/styles/global';
import { StyledFormElements } from '@tmh-website/ui/FormElements';
import styled, { css } from 'styled-components';
import { FormElementThemeColor, formElementThemes } from '@tmh-website/ui/FormElements';
import transparentize from 'polished/lib/color/transparentize';

export const Wrapper = styled.div`
  input {
    appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      appearance: none;
      margin: 0;
    }
  }

  ${StyledFormElements.ExtraElement} {
    width: 30px;
  }
`;

export const ChangeValueButton = styled.button<{ $disabled: boolean; $themeColor: FormElementThemeColor }>`
  ${resetButtonStylingCSS};
  display: block;
  width: 30px;
  height: 22px;
  border-left: 2px solid ${props => props.theme.color[formElementThemes[props.$themeColor].border.normal]};
  transition: background-color ${props => props.theme.transitionTiming}, color ${props => props.theme.transitionTiming};

  &:first-child {
    border-bottom: 1px solid ${props => props.theme.color[formElementThemes[props.$themeColor].border.normal]};
  }

  &:last-child {
    border-top: 1px solid ${props => props.theme.color[formElementThemes[props.$themeColor].border.normal]};
  }

  &:hover {
    background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].border.normal]};
  }

  ${props =>
    props.$disabled &&
    css`
      pointer-events: none;
      color: ${transparentize(0.8, props.theme.color[formElementThemes[props.$themeColor].text])};
    `};

  svg {
    margin-left: 6px;
  }
`;
